var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useCurrentSector } from "../../utils/hooks/sector/useSectors";
import { thinScrollbarSx } from "../../utils/scrollbar.util";
import FullProfilePane from "./fullProfile/FullProfilePane";
import FullProfileToolbar from "./fullProfile/FullProfileToolbar";
import ProfileSidebar from "./sidebar/ProfileSidebar";
import { useProfilePreview } from "./useProfilePreview";
var ProfilePreview = function (props) {
    var _a;
    var _b = useProfilePreview(props.profile, props.onProfileChange), profile = _b.profile, setProfile = _b.setProfile;
    var sector = useCurrentSector();
    var searchParams = useSearchParams()[0];
    var voiceNoteId = (_a = searchParams.get('voiceNoteId')) !== null && _a !== void 0 ? _a : undefined;
    if (!profile)
        return null;
    var sidebar = (_jsx(ProfileSidebar, { profile: profile, onProfileChange: setProfile, mode: props.mode, sector: sector, voiceNoteId: voiceNoteId, reservationId: props.reservationId, otherGuests: props.otherGuests, bookingDetails: props.bookingDetails, onOpenFullProfile: props.onOpenFullProfile, onBackToReservation: props.onBackToReservation, onRemoveFromReservation: props.onRemoveFromReservation }));
    if (props.mode === 'simple')
        return sidebar;
    return (_jsxs(Stack, __assign({ sx: { flex: 1, minHeight: 0, position: 'relative' } }, { children: [_jsx(FullProfileToolbar, { profile: profile, reservation: props.reservation, reservationId: props.reservationId, onClose: props.onClose }), _jsxs(Stack, __assign({ sx: {
                    width: '100%',
                    flexDirection: 'column',
                    flex: { md: 1 },
                    minHeight: { md: 0 },
                    '@media (min-width:768px)': { flexDirection: 'row' }
                } }, { children: [sidebar, _jsx(Divider, { orientation: 'vertical', flexItem: true }), _jsx(Box, __assign({ sx: __assign({ flex: 1, minWidth: 0, display: 'flex', overflowY: { xs: 'visible', md: 'auto' } }, thinScrollbarSx) }, { children: _jsx(FullProfilePane, { profile: profile, setProfile: setProfile, voiceNoteId: voiceNoteId, sector: sector, actions: props.actions }) }))] }))] })));
};
export default ProfilePreview;
